// extracted by mini-css-extract-plugin
export default {"component_podcasts_table":"podcasts-table_component_podcasts_table__fZ8V0"};